// Phase-102 · RoleGate HOC.
// Reads role + scope from authStore and renders children if allowed.
// Props:
//   allow={['admin','founder']}   — string array of allowed roles
//   denyBelowTier={2}              — alternative; user must have tier <= n
//   fallback                       — optional custom 403 component
//
// Used as the first consumer of the new role/scope plumbing. Future
// admin pages will wrap themselves with <RoleGate allow={[...]}>.
import useAuthStore from "../store/authStore";
import Forbidden403 from "./Forbidden403";

const ROLE_TIER = {
  founder: 0, ceo: 1, admin: 2,
  main_hub_manager: 3, city_manager: 3,
  micro_hub_lead: 4,
  ops_staff: 5, agent: 5,
  user: 6,
};

export default function RoleGate({ allow, denyBelowTier, children, fallback }) {
  const user = useAuthStore((s) => s.user);
  const role = user?.role || "user";

  let allowed = true;
  let reason = "";
  if (Array.isArray(allow) && allow.length > 0) {
    if (!allow.includes(role)) {
      allowed = false;
      reason = `Requires one of: ${allow.join(", ")}`;
    }
  }
  if (allowed && typeof denyBelowTier === "number") {
    if ((ROLE_TIER[role] ?? 99) > denyBelowTier) {
      allowed = false;
      reason = `Requires tier ${denyBelowTier} or higher`;
    }
  }

  if (!allowed) return fallback || <Forbidden403 reason={reason} role={role} />;
  return children;
}
